import React from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/gluestack/text';
import { ButtonWrapper } from '@/components/ui/ButtonWrapper';
import { Refresh01Icon } from '@hugeicons-pro/core-stroke-rounded';

interface Props {
  onReload: () => void;
}

export function UpdateBanner({ onReload }: Props) {
  const { t } = useTranslation();

  return (
    <View className="flex-row items-center justify-center gap-3 bg-secondary-700 dark:bg-secondary-200 px-4 py-2.5">
      <Text size="sm" className="font-medium text-secondary-200 dark:text-secondary-800">
        {t('common.updateBanner.message')}
      </Text>
      <ButtonWrapper
        icon={Refresh01Icon}
        text={t('common.updateBanner.refresh')}
        action="secondary"
        size="xs"
        onPress={onReload}
      />
    </View>
  );
}
